import styled from "@emotion/styled";
import colors from "../../../styles/colors";
export const ReactSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 100%;
  position: relative;
  display: inline-block;
  :before {
    content: "";
    position: absolute;
    right: 0.3125rem;
    z-index: 2;
    top: 0;
    bottom: 0;
    width: 0.75rem;
    pointer-events: none;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23054bc7' width='20' height='20' viewBox='0 0 20 20' fill-rule='evenodd'%3E%3Cpath d='M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z'%3E%3C/path%3E%3C/svg%3E")
      center / contain no-repeat;
    background-position-y: 58%;
  }
  ${(props) => props.disabled &&
    `
      :before {
        display: none;
      }
    `}
`;
export const ListItemStyled = styled.li `
  padding: 0rem;
  cursor: pointer;
`;
export const UnOrderedListStyled = styled.ul `
  font-family: Inter;
  width: 100%;
  padding: 0rem;
  margin: 0rem;
  list-style-type: none;
  max-height: 18rem;
  overflow-y: auto;
  position: absolute;
  margin-top: 0.125rem;
  border-radius: 0.25rem;
  border: 0.078rem solid ${colors["color-gray-30"]};
  background-color: ${colors["color-white-100"]};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  max-height: ${(props) => props.maxDropdownHeight ? `${props.maxDropdownHeight}` : "none"};
`;
export const ListItemLabelStyled = styled.div `
  font-family: Inter;
  font-family: Inter;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.125rem;
  letter-spacing: 0em;
  text-align: left;
  padding: 0.25rem 0.75rem;
  height: 2.25rem;
  display: flex;
  align-items: center;

  background-color: ${(props) => props.isInFocus
    ? `${colors["color-blue-30"]}`
    : `${colors["color-white-100"]}`};

  :hover {
    background-color: ${colors["color-blue-30"]};
  }
`;
//# sourceMappingURL=TypeAheadDropdown.styled.js.map